import React, { useState } from "react";
import { useNavigate } from "react-router";
import { post } from "../../../Server";

const useCheckMobile = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const check = async () => {
    setLoading(true);
    const { data } = await post(
      "/check",
      {
        ...form,
      },
      true
    );
    if (data.user == "true") {
      navigate("/verify-code", { state: { mobile: form.mobile } });
    }
    if (data.user == "false") {
      navigate("/sign-up", { state: { mobile: form.mobile } });
    }
    setLoading(false);
  };
  return {
    loading,
    form,
    check,
    setForm,
  };
};

export default useCheckMobile;
